import { Avatar, Button, Grid, makeStyles, Typography, ListItemIcon, Menu, MenuItem } from "@material-ui/core";
import React, { useCallback, useRef, useState } from "react";
import { useReactOidc } from "@axa-fr/react-oidc-context";
import avatar_default from "assets/img/default-avatar.png";
import UserMenuStyle from "../styles";
import { ExitToApp, PersonOutline } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { useHistory } from "react-router-dom";
import { emptyString } from "constants/defaultValues";
import { USER_BASIC_INFO } from "../queries";
import useUserData from "hooks/useUserData";
import { env } from "utils/env";

const useStyles = makeStyles(UserMenuStyle);

function UserMenu() {
  const { logout, oidcUser } = useReactOidc();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const logoutAction = useCallback(
    (e) => {
      e.preventDefault();
      if (typeof logout === "function") logout();
    },
    [logout]
  );
  const handleClick = useCallback(() => {
    setOpen((prevOpen) => !prevOpen);
  }, []);

  const handleProfileOption = useCallback(() => {
    history.push(`/my-profile`);
  }, [history]);

  const { userRights } = useUserData();
  const { data } = useQueryWithErrorHandling(USER_BASIC_INFO);

  return (
    <>
      <Button className={classes.buttonStyle} variant="contained" onClick={handleClick} ref={anchorRef}>
        <Avatar src={data?.getUserProfile?.picture || avatar_default}></Avatar>
        {data && (
          <Grid container className={classes.buttonProfile} spacing={1} direction="column">
            <Grid item>{data?.getUserProfile?.firstName + " " + data?.getUserProfile?.lastName || emptyString}</Grid>
            {!userRights?.hasVendorAdminUserRight && (
              <Grid item className={classes.dealerStyle}>
                {data?.getUserProfile?.dealerName || emptyString}
              </Grid>
            )}
          </Grid>
        )}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClick}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem onClick={handleProfileOption}>
          <ListItemIcon>
            <PersonOutline />
          </ListItemIcon>
          <Typography classes={classes.itemText}>{t("NavBar.MyProfile")}</Typography>
        </MenuItem>
        {oidcUser && env.REACT_APP_USE_CIAM?.toLowerCase() !== "true" && (
          <MenuItem onClick={logoutAction}>
            <ListItemIcon>
              <ExitToApp />
            </ListItemIcon>
            <Typography classes={classes.itemText}>{t("NavBar.Logout")}</Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
}

export default UserMenu;
